import { create } from 'zustand';
import type { ListActivePaymentDto } from '../../generated-api';

interface FocusedPaymentState {
  focusedPayment: ListActivePaymentDto | undefined;
  setFocusedPayment: (payment: ListActivePaymentDto | undefined) => void;
}

export const useFocusedPaymentStore = create<FocusedPaymentState>((set) => ({
  focusedPayment: undefined,
  setFocusedPayment: (payment) => set({ focusedPayment: payment }),
}));
